import type { JSX } from 'react'
import type { IRadioProps } from '../RadioButton'

import { Radio } from '../RadioButton'

export interface IRadioAccentMain extends IRadioProps {
  id: string
  name: string
}

export const RadioAccentMain = ({
  id,
  name,
  ...rest
}: IRadioAccentMain): JSX.Element => {
  return <Radio id={id} name={name} {...rest} />
}
